module.exports = __webpack_public_path__ + "static/img/sz.2be7ffd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sz.png
// module id = jQYr
// module chunks = 1